import { AppBar, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material';
import { Link } from 'react-router';
import britestageLogo from '@/assets/britestage-logo.png';
import ThemeSwitch from '@/components/common/theme-switch';

export default function LegalHeader() {
  const theme = useTheme();

  return (
    <AppBar
      position="fixed"
      sx={{
        left: 0,
        top: 0,
        boxShadow: 'none',
        zIndex: theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar
        sx={{
          px: { xs: 2, md: 3 },
          minHeight: { xs: '50px', md: '64px' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: theme.palette.background.topbar,
        }}
      >
        <Link to="/" style={{ textDecoration: 'none' }}>
          <img
            src={britestageLogo}
            alt="Britestage Logo"
            style={{
              width: '172px',
              height: '40.89px',
              objectFit: 'contain',
              cursor: 'pointer',
              display: 'block',
            }}
          />
        </Link>
        <ThemeSwitch />
      </Toolbar>
    </AppBar>
  );
}
